import { createApp } from 'vue'
import App from './App.vue'
import axios from "axios"
import './assets/style.css'
import './scripts/igniteUI/css/structure/infragistics.css'
import './scripts/igniteUI/css/themes/infragistics/infragistics.theme.css'
import './scripts/igniteUI/css/themes/infragistics2012/infragistics.theme.css'

//note: if changing the virtual directory in this file, do so also in vue.config.js

axios.defaults.baseURL = '/DuProcessLandRedemption/'
//axios.defaults.baseURL = '/DuProcessLandRedemptionBeta/' //ensure the vue.config.js is also updated to Beta
//axios.defaults.baseURL = 'http://localhost:63075/'
//axios.defaults.baseURL = 'https://landrecords.co.harrison.ms.us/DuProcessLandRedemption'
//axios.defaults.baseURL = 'https://www.georgecountyrecords.com/DuProcessLandRedemption/'
//axios.defaults.baseURL = 'https://www2.rankincounty.org/DuProcessLandRedemption/'

axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

createApp(App).mount('#app')
